module.exports = __webpack_public_path__ + "img/524.5afafe3a.png";